import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../actions/modal';
import { clearOtpGenerateStore, updateUserProfile } from '../../actions/users';
import Form from '../../common/Form';
import { useForm } from 'react-hook-form';
import Address, { transformAddress } from '../../components/Inputs/Address';
const formName = 'updateRequiredFields';

export default function UpdatRequiredFields({ showCancelButton = false }) {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const defaultValues = {
        address: newLoggedUserData?.user?.address?.plain_text || ''
    };

    useEffect(() => {
        dispatch(clearOtpGenerateStore());
    }, [dispatch]);

    const submit = (formValues) => {
        dispatch(updateUserProfile({ payload: { address: transformAddress(formValues, 'address') }, userId: newLoggedUserData?.user?.id, formName, callLoginUserDetails: true }));
    };

    const methods = useForm({ defaultValues, mode: 'all' });


    return (
        <div className='p-2'>
            <Form
                methods={methods}
                onSubmit={submit}
                submitButtonText={'Submit'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
                showCancelButton={showCancelButton}
            >
                <div className='grid grid-cols-2 rows-fr  items-end pt-2'>
                    <Address id="address" name="address" label="Working Location" required={true} placeholder="Type your address..." className='w-full col-span-2' />
                </div>
            </Form>
        </div>
    );
}
